module.exports = __webpack_public_path__ + "img/couples_11_V.e7f3bc68.webp";